import { isValidTags } from './validators/functions/is-valid-tags.function';

export * from './dtos/create-tag.dto';
export * from './dtos/tag.dto';
export * from './dtos/tag-list.dto';
export * from './dtos/tag-record.dto';
export * from './dtos/tag-search.dto';
export * from './dtos/tags-stats.dto';
export * from './dtos/update-tag.dto';

export * from './enums/tag-record-category.enum';

export * from './functions/tag-category-to-color.function';

export * from './types/tags-filters';

export * from './validators/schemas/create-tag.schema';
export * from './validators/schemas/create-tags.schema';
export * from './validators/schemas/update-tag.schema';

export const tagsValidators = { isValidTags };
